import { CheckCircle2, XCircle } from "lucide-react";

const CHECKLIST_LABELS = {
  problem_statement: "Problem Statement (Define)",
  smart_goal: "SMART Goal (Define)",
  sipoc: "SIPOC Diagram (Define)",
  stakeholders: "Stakeholder Map (Define)",
  financial_impact: "Financial Impact (Define)",
  dataset_uploaded: "Dataset Uploaded (Measure)",
  baseline_calculated: "Baseline Calculated (Measure)",
  control_chart_run: "Control Chart Run (Measure)",
  root_cause_analysis: "Root Cause Analysis (Analyze)",
  solutions_defined: "Solutions Defined (Improve)",
  fmea_completed: "FMEA Completed (Improve)",
  control_plan: "Control Plan (Control)",
  kpis_defined: "KPIs Defined (Control)",
};

export function ClosureChecklistTab({ checklist }) {
  if (!checklist) return null;

  return (
    <div className="bg-card border border-border rounded-lg p-6 space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="font-heading font-semibold">Closure Readiness Checklist</h3>
        <span className={`text-xs font-semibold px-3 py-1 rounded-full ${checklist.all_met ? "bg-emerald-500/15 text-emerald-400" : "bg-amber-500/15 text-amber-400"}`} data-testid="checklist-status-badge">
          {checklist.passed}/{checklist.total} {checklist.all_met ? "Ready" : "Incomplete"}
        </span>
      </div>

      {/* Progress bar */}
      <div className="w-full bg-muted rounded-full h-2">
        <div
          className={`h-2 rounded-full transition-all ${checklist.all_met ? "bg-emerald-500" : "bg-amber-500"}`}
          style={{ width: `${(checklist.passed / checklist.total) * 100}%` }}
          data-testid="checklist-progress-bar"
        />
      </div>

      <div className="grid md:grid-cols-2 gap-3" data-testid="checklist-items">
        {Object.entries(checklist.items || {}).map(([key, passed]) => (
          <div key={key} className={`flex items-center gap-3 p-3 rounded-lg border ${passed ? "border-emerald-500/20 bg-emerald-500/5" : "border-red-500/20 bg-red-500/5"}`} data-testid={`checklist-item-${key}`}>
            {passed ? (
              <CheckCircle2 className="w-4 h-4 text-emerald-400 shrink-0" />
            ) : (
              <XCircle className="w-4 h-4 text-red-400 shrink-0" />
            )}
            <span className="text-sm">{CHECKLIST_LABELS[key] || key.replace(/_/g, " ")}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
